import React from "react";
import styles from "./PricingPage.scss";
import classnames from "classnames";
import SiteContainer from "components/homepage/SiteContainer";
import * as ComparisonData from "constants/site/PricingComparison";
import ComparisonChart from "components/site/widgets/ComparisonChart";

export default function PricingPage(props) {
    return (
        <SiteContainer minimal>
            <div className={styles.root}>
                <header>
                    <h2>Pricing</h2>
                </header>
                <div className={styles.content}>
                    <div className={styles.pricingInfo}>
                        <h3>JazzWire Subscription</h3>
                        <div className={styles.priceRate}>
                            $<span className={styles.priceValue}>49.95</span>&nbsp;/ Month
                        </div>
                        <ul className={styles.pricingIncludes}>
                            <li>$75 Initial Application Fee</li>
                            <li>Personalized Playing Evaluations</li>
                            <li>Access to the Jazz Wire Community</li>
                            <li>Six-Month Practice Plan</li>
                        </ul>
                        <div className={styles.signupButton}>
                            <a className="btn btn-full" href="/sign-up" title="Sign Up">Sign Up </a>
                        </div>
                    </div>
                </div>
                <div className={classnames(styles.content, styles.additionalInfo)}>
                    <div className={styles.productDescription}>
                        <h2>The JazzWire Difference</h2>
                        <p>At JazzWire, we take pride in getting to know each student and providing them with the guidance and challenge they need to progress.</p>
                        <p>Our master teachers have successfully taught thousands of adult students using a philosophy of small, consistent steps reinforced with repetition, encouragement, and camaraderie.</p>
                        <p>Let us help you become the improviser you aspire to be.</p>
                    </div>
                </div>
                <div className={classnames(styles.content, styles.additionalInfo)}>
                    <div className={styles.comparisonInfo}>
                        <h3>How JazzWire Compares</h3>
                        <ComparisonChart
                            firstColumnLabel = {ComparisonData.FIRST_COLUMN_LABEL}
                            columns={ComparisonData.CHECK_COLUMN_LABELS}
                            data={ComparisonData.COMPARISON_ROWS}
                        />
                    </div>
                </div>
            </div>
        </SiteContainer>
    )
}
